import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

type TabMenuButtonProps = {
  className?: string;
  children: string;
  isActive: boolean;
  onClick?: () => void;
};

const TabMenuButton = (props: TabMenuButtonProps) => {
  const { className, children, onClick } = props;

  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  );
};

const StyledTabMenuButton = styled(TabMenuButton)<TabMenuButtonProps>`
  border-bottom: 2px solid;
  border-color: ${(props) => (props.isActive ? theme.colors.Blue : 'transparent')};
  color: ${({ theme }) => theme.colors.InkPrimary};
  cursor: ${(props) => (props.isActive ? 'default' : 'pointer')};
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  font-size: 15px;

  transition: color 0.25s ease;

  &:hover {
    color: ${({ isActive, theme }) => (isActive ? theme.colors.InkPrimary : theme.colors.AccentJonquil)};
  }
`;

export default StyledTabMenuButton;
